import React, { useState } from 'react';
import { PlayCircleFilled } from '@ant-design/icons';
import { useParams } from 'react-router-dom';
import { message } from 'antd';
import { getFullFileUrl } from '../../../../../../../Common/Uploaders/ImageUpload';
import EmptyImage from '../../Empty';
import UploadUserMediaModal from '../UploadMediaModal';
import { DeleteButton, EditButton, UserMarathonThumbnailProps } from '../ThumbnailImage';
import { useSimpleModal } from '../../../../../../../Common/Modal/Simple';
import { useUserMarathonMediaDelete } from '../../../../../../../../hooks/api/user';
import { capitalizeFirstLetter } from '../../../../../../../../utils';
import { useUserProfileProvider } from '../../../../../../../../context/userProfile';

function UserMarathonVideoThumbnail({
  media, editProps, selectedMarathon,
}: UserMarathonThumbnailProps) {
  const [modalOpen, setModalOpen] = useState(false);
  /** Deletion logic */
  const { id: userId = '' } = useParams<{ id: string; }>();
  const { userById } = useUserProfileProvider();
  const { open: openConfirm, contextHolder } = useSimpleModal();

  const requestUrl = editProps && selectedMarathon?.id
    ? `${userId}/participants/${selectedMarathon.id}/measure${
      capitalizeFirstLetter(editProps.measure)}/${editProps.dataKey}` : '';
  const userMarathonImageDelete = useUserMarathonMediaDelete(requestUrl);

  /** General */
  const handleOpen = (open: boolean) => {
    setModalOpen(open);
  };

  if (!editProps?.withEdit) {
    return (
      media ? (
        <>
          <PlayCircleFilled className="video-play-icon" />
          <video src={getFullFileUrl(media)} preload="metadata">
            <track kind="captions" />
          </video>
        </>
      ) : <EmptyImage />
    );
  }

  const handleDelete = () => {
    openConfirm({
      title: 'Удалить медиа-файл?',
      content: 'Вы уверены, что хотите удалить этот медиа-файл?',
      cancelText: 'Отмена',
      centered: true,
      okText: 'Удалить',
      okButtonProps: {
        type: 'primary',
        danger: true,
      },
      onOk: () => userMarathonImageDelete.fetch(
        undefined,
        requestUrl,
      ).then(() => {
        message.success('Медиа успешно удалено!');
        userById.fetch(undefined, userId);
      }),
      maskClosable: true,
    });
  };

  /** If withEdit then render edit icon and modal for edit image */
  return (
    <>
      <UploadUserMediaModal
        variant="video"
        media={media}
        dataKey={editProps.dataKey}
        open={modalOpen}
        handleOpen={handleOpen}
        measure={editProps.measure}
        participantId={selectedMarathon?.id || ''}
      />

      {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions */}
      <div onClick={(e) => e.stopPropagation()}>
        {contextHolder}
      </div>
      {media && (<DeleteButton onClick={() => handleDelete()} />)}
      <EditButton onClick={() => handleOpen(true)} />

      <PlayCircleFilled className="video-play-icon" />
      <video src={getFullFileUrl(media)} preload="metadata">
        <track kind="captions" />
      </video>
    </>
  );
}

UserMarathonVideoThumbnail.defaultProps = {
  media: undefined,
};

export default UserMarathonVideoThumbnail;
